import 'dayjs/locale/th';
import dayjs, { Dayjs } from 'dayjs';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { AdapterFormats } from '@mui/x-date-pickers/models';

dayjs.extend(buddhistEra);

export default class BuddhistAdapter extends AdapterDayjs {
  constructor({
    locale,
    formats,
    instance,
  }: {
    locale: string;
    formats: AdapterFormats;
    instance: any;
  }) {
    super({ locale, formats, instance });
  }

  formatByString = (date: Dayjs, format: string) => {
    const newFormat = format.replace(/\bYYYY\b/g, 'BBBB');
    return this.dayjs(date).format(newFormat);
  };
}
